"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CloudimageContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _throttleDebounce = require("throttle-debounce");

var _cloudimageResponsiveUtils = require("cloudimage-responsive-utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CloudimageContext = _react["default"].createContext({
  config: {}
});

exports.CloudimageContext = CloudimageContext;

var CloudimageProvider = /*#__PURE__*/function (_Component) {
  _inherits(CloudimageProvider, _Component);

  var _super = _createSuper(CloudimageProvider);

  function CloudimageProvider() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$config = _ref.config,
        config = _ref$config === void 0 ? {} : _ref$config;

    _classCallCheck(this, CloudimageProvider);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "updateDimensions", (0, _throttleDebounce.debounce)(100, function () {
      _this.setState({
        innerWidth: window.innerWidth
      });
    }));

    var _config$token = config.token,
        token = _config$token === void 0 ? '' : _config$token,
        _config$domain = config.domain,
        domain = _config$domain === void 0 ? 'cloudimg.io' : _config$domain,
        _config$lazyLoading = config.lazyLoading,
        lazyLoading = _config$lazyLoading === void 0 ? true : _config$lazyLoading,
        _config$lazyLoadOffse = config.lazyLoadOffset,
        lazyLoadOffset = _config$lazyLoadOffse === void 0 ? 100 : _config$lazyLoadOffse,
        _config$placeholderBa = config.placeholderBackground,
        placeholderBackground = _config$placeholderBa === void 0 ? '#f4f4f4' : _config$placeholderBa,
        baseUrl = config.baseUrl,
        baseURL = config.baseURL,
        presets = config.presets,
        _config$ratio = config.ratio,
        ratio = _config$ratio === void 0 ? 1.5 : _config$ratio,
        _config$params = config.params,
        params = _config$params === void 0 ? 'org_if_sml=1' : _config$params,
        _config$exactSize = config.exactSize,
        exactSize = _config$exactSize === void 0 ? false : _config$exactSize,
        _config$doNotReplaceU = config.doNotReplaceURL,
        doNotReplaceURL = _config$doNotReplaceU === void 0 ? false : _config$doNotReplaceU,
        _config$limitFactor = config.limitFactor,
        limitFactor = _config$limitFactor === void 0 ? 100 : _config$limitFactor,
        _config$devicePixelRa = config.devicePixelRatioList,
        devicePixelRatioList = _config$devicePixelRa === void 0 ? _cloudimageResponsiveUtils.CONSTANTS.DEVICE_PIXEL_RATIO_LIST : _config$devicePixelRa,
        _config$lowQualityPre = config.lowQualityPreview;
    _config$lowQualityPre = _config$lowQualityPre === void 0 ? {} : _config$lowQualityPre;
    var _config$lowQualityPre2 = _config$lowQualityPre.minImgWidth,
        minImgWidth = _config$lowQualityPre2 === void 0 ? 250 : _config$lowQualityPre2;
    _this.state = {
      token: token,
      domain: domain,
      lazyLoading: lazyLoading,
      lazyLoadOffset: lazyLoadOffset,
      placeholderBackground: placeholderBackground,
      baseURL: baseUrl || baseURL,
      ratio: ratio,
      exactSize: exactSize,
      presets: presets ? presets : {
        xs: '(max-width: 575px)',
        // to 575       PHONE
        sm: '(min-width: 576px)',
        // 576 - 767    PHABLET
        md: '(min-width: 768px)',
        // 768 - 991    TABLET
        lg: '(min-width: 992px)',
        // 992 - 1199   SMALL_LAPTOP_SCREEN
        xl: '(min-width: 1200px)' // from 1200    USUALSCREEN

      },
      params: (0, _cloudimageResponsiveUtils.processParams)(params),
      innerWidth: typeof window !== 'undefined' ? window.innerWidth : null,
      previewQualityFactor: 10,
      doNotReplaceURL: doNotReplaceURL,
      devicePixelRatioList: devicePixelRatioList,
      limitFactor: limitFactor,
      minLowQualityWidth: minImgWidth
    };

    if (typeof window !== 'undefined') {
      _this.state.innerWidth = window.innerWidth;
      window.addEventListener("resize", _this.updateDimensions);
    }

    return _this;
  }

  _createClass(CloudimageProvider, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(CloudimageContext.Provider, {
        value: {
          config: this.state
        }
      }, this.props.children);
    }
  }]);

  return CloudimageProvider;
}(_react.Component);

var _default = CloudimageProvider;
exports["default"] = _default;